<template>
    <div>
      <LabdaqInvalidOrders></LabdaqInvalidOrders>
    </div>
  </template>
  
  <script>
  const LabdaqInvalidOrders = defineAsyncComponent(() =>
    import("@/components/cases/LabdaqInvalidOrders")
  );
  import { defineAsyncComponent } from "vue";
  export default {
    components: {
      LabdaqInvalidOrders,
    },
  };
  </script>
  